var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamicalDevicePage"},[_vm._v("系统设备")])
}
var staticRenderFns = []

export { render, staticRenderFns }